// utils/openDiscover.js  (前端 JS / ES6)
import { Modal } from 'antd';

/**
 * 在新标签打开 Discover；若被拦截或无 URL，则用 AntD 英文弹窗提示。
 * 注意：务必在用户点击事件中调用，否则大概率被拦截。
 * @param {string|null|undefined} bitlyUrl
 */
export const openDiscover = (bitlyUrl) => {
  const url = typeof bitlyUrl === 'string' ? bitlyUrl.trim() : '';

  // 无 URL：只弹英文提示，不跳转
  if (!url) {
    Modal.info({
      title: 'Discover is not ready',
      content:
        'Discover for this area is under construction. Please check back later.',
      okText: 'OK',
      centered: true,
    });
    return;
  }

  // 方案：先开 about:blank（需处于用户手势中），再在新标签跳转到目标 URL
  // 这样大多浏览器会返回 Window 对象，可用于判断是否被拦截
  let win = null;
  try {
    win = window.open('', '_blank'); // 不要带 noreferrer/noopener，否则有的浏览器直接返回 null
  } catch {
    win = null;
  }

  if (win) {
    try {
      // 断开反向引用，防止 tabnabbing
      win.opener = null;
      // 新标签跳转到目标地址
      win.location.assign(url);
      return;
    } catch {
      // 个别环境可能不允许赋值 location；降级再尝试直接打开
      window.open(url, '_blank');
      return;
    }
  }

  // 若被拦截（win 为 null），给用户选择在当前页打开
  Modal.confirm({
    title: 'Your browser blocked the new tab',
    content:
      'Would you like to open the link in this tab instead?',
    okText: 'Open here',
    cancelText: 'Cancel',
    centered: true,
    onOk: () => window.location.assign(url),
  });
};
